import { useContext } from "react";
import Grid from "@mui/material/Unstable_Grid2";
import { DefaultLayout } from "../../../layouts/DefaultLayout";
import { AppContext } from "../../root/Root";

// ✅ import par défaut
import MediaClassificationComponent from "../../../components/audience/mediaClassification/MediaClassification";

// ✅ Export NOMMÉ pour correspondre à: import {MediaClassification} from ".../pages/..."
export function MediaClassification() {
  useContext(AppContext);
  return (
    <DefaultLayout>
      <Grid
        className="page-content"
        container
        rowSpacing={{ xs: 3, md: 0 }}
        columnSpacing={{ xs: 0, md: 2 }}
        padding={{ xs: 1, md: 2 }}
        disableEqualOverflow
      >
        <Grid md={12}>
          <MediaClassificationComponent />
        </Grid>
      </Grid>
    </DefaultLayout>
  );
}
